import { OAuth2Api } from '../../generated/api';
import configuration from './configuration';

const oauth2Service = new OAuth2Api(configuration);

export default oauth2Service;
